import { transactionConstants } from "../constansts/transaction.constants";

const initialState = {
  data: [],
  success: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case transactionConstants.TRANSTATION_LIST:
      return {
        ...state,
        data: action.data,
        success: true
      };

    default:
      return state;
  }
}
